(function() {
  var page = document.querySelector('[data-b2b-page]');
  if (!page) return;

  var cartCount = Number(page.getAttribute('data-initial-cart-count') || 0);
  var routesRoot = '/';

  if (window.Shopify && Shopify.routes && Shopify.routes.root) {
    routesRoot = Shopify.routes.root;
  }

  function t(value) {
    return String(value || '');
  }

  function runWhenReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function hideHeaderMenuButton() {
    var selectors = [
      '.shopify-section-header header-drawer',
      '.shopify-section-header .header-drawer',
      '.shopify-section-header .header__offcanvas-toggle',
      '.shopify-section-header .aside-menu__toggle',
      '.shopify-section-header .aside-menu__toggle--open-btn',
      '.shopify-section-header button[aria-label="Zijmenu"]',
      '.shopify-section-header button[aria-label="Menu"]'
    ];

    selectors.forEach(function(selector) {
      document.querySelectorAll(selector).forEach(function(element) {
        element.style.display = 'none';
        element.style.visibility = 'hidden';
        element.style.pointerEvents = 'none';
      });
    });
  }

  function setupHeaderMenu() {
    hideHeaderMenuButton();

    var menus = [
      document.querySelector('.shopify-section-header .header__inline-menu .list-menu--inline'),
      document.querySelector('.shopify-section-header .header__inline-menu ul')
    ].filter(Boolean);

    if (!menus.length) return false;

    menus.forEach(function(menu) {
      var sampleLink = menu.querySelector('a');
      var sampleLi = menu.querySelector('li');
      var linkClass = sampleLink ? sampleLink.className : 'list-menu__item link';
      var liClass = sampleLi ? sampleLi.className : '';

      menu.innerHTML = '';

      [
        { label: 'Zakelijk bestellen', url: '/collections/zakelijk-bestellen' },
        { label: 'Contact', url: '/pages/contact' }
      ].forEach(function(item) {
        var li = document.createElement('li');
        var a = document.createElement('a');

        li.className = liClass;
        li.removeAttribute('open');

        a.href = item.url;
        a.textContent = item.label;
        a.className = linkClass;
        a.removeAttribute('aria-current');
        a.removeAttribute('aria-expanded');
        a.removeAttribute('aria-controls');
        a.removeAttribute('role');

        a.addEventListener('mouseenter', function(event) {
          event.stopPropagation();
        }, true);

        a.addEventListener('mouseover', function(event) {
          event.stopPropagation();
        }, true);

        li.appendChild(a);
        menu.appendChild(li);
      });
    });

    document.querySelectorAll('.shopify-section-header details[open]').forEach(function(details) {
      details.removeAttribute('open');
    });

    document.querySelectorAll(
      '.shopify-section-header .mega-menu, .shopify-section-header .mega-menu__content, .shopify-section-header .disclosure__list, .shopify-section-header .list-menu--disclosure'
    ).forEach(function(dropdown) {
      dropdown.setAttribute('hidden', 'hidden');
      dropdown.style.display = 'none';
      dropdown.style.pointerEvents = 'none';
    });

    return true;
  }

  function setupHeaderWithRetry() {
    var tries = 0;

    function attempt() {
      var ok = setupHeaderMenu();

      if (!ok && tries < 25) {
        tries += 1;
        window.setTimeout(attempt, 120);
      }
    }

    attempt();
  }

  function getHeaderCartLinks() {
    var all = document.querySelectorAll('.shopify-section-header a[href*="/cart"], .shopify-section-header #cart-icon-bubble');
    var unique = [];

    all.forEach(function(element) {
      if (unique.indexOf(element) === -1) unique.push(element);
    });

    return unique;
  }

  function cleanCartLinkText(link) {
    if (!link) return;

    link.style.display = '';
    link.removeAttribute('hidden');
    link.setAttribute('aria-label', 'Winkelwagen');

    Array.prototype.slice.call(link.childNodes).forEach(function(node) {
      if (node.nodeType === 3 && node.textContent && node.textContent.trim() !== '') {
        node.textContent = '';
      }
    });

    link.querySelectorAll('span').forEach(function(span) {
      if (span.classList.contains('b2b-cart-badge')) return;
      if (span.classList.contains('b2b-cart-icon-wrap')) return;
      if (span.closest('svg')) return;

      var text = (span.textContent || '').trim().toLowerCase();

      if (
        span.classList.contains('visually-hidden') ||
        text.indexOf('winkelwagen') !== -1 ||
        /^[0-9]+$/.test(text)
      ) {
        span.style.display = 'none';
      }
    });
  }

  function ensureHeaderCartIcon(link) {
    if (!link) return;

    cleanCartLinkText(link);

    var hasVisibleIcon = false;

    link.querySelectorAll('svg, .icon, [class*="icon-cart"], [class*="cart-icon"]').forEach(function(icon) {
      if (icon.classList && (icon.classList.contains('b2b-cart-icon') || icon.classList.contains('b2b-cart-icon-wrap'))) return;

      icon.style.display = '';
      icon.style.visibility = 'visible';
      hasVisibleIcon = true;
    });

    if (!hasVisibleIcon && !link.querySelector('.b2b-cart-icon-wrap')) {
      var wrap = document.createElement('span');

      wrap.className = 'b2b-cart-icon-wrap';
      wrap.setAttribute('aria-hidden', 'true');
      wrap.innerHTML = '<svg class="b2b-cart-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 5H6.2L8.05 14.15C8.16 14.69 8.63 15.08 9.18 15.08H17.55C18.08 15.08 18.55 14.72 18.68 14.2L20 8.5H7.05" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.5 20C10.19 20 10.75 19.44 10.75 18.75C10.75 18.06 10.19 17.5 9.5 17.5C8.81 17.5 8.25 18.06 8.25 18.75C8.25 19.44 8.81 20 9.5 20Z" fill="currentColor"/><path d="M17.5 20C18.19 20 18.75 19.44 18.75 18.75C18.75 18.06 18.19 17.5 17.5 17.5C16.81 17.5 16.25 18.06 16.25 18.75C16.25 19.44 16.81 20 17.5 20Z" fill="currentColor"/></svg>';

      link.insertBefore(wrap, link.firstChild);
    }
  }

  function updateStickyCart(count) {
    var sticky = document.querySelector('[data-b2b-sticky-cart]');
    var stickyCount = document.querySelector('[data-b2b-sticky-count]');

    if (!sticky || !stickyCount) return;

    if (count > 0) {
      sticky.hidden = false;
      stickyCount.textContent = count === 1 ? '1 product in winkelwagen' : count + ' producten in winkelwagen';
    } else {
      sticky.hidden = true;
      stickyCount.textContent = '0 producten in winkelwagen';
    }
  }

  function updateHeaderCartCount(count) {
    cartCount = Math.max(0, Number(count) || 0);

    document.querySelectorAll('[data-b2b-cart-link]').forEach(function(link) {
      link.innerHTML = cartCount > 0
        ? t('Naar winkelwagen') + ' <span class="b2b-cart-link-count">(' + cartCount + ')</span>'
        : t('Naar winkelwagen');
    });

    getHeaderCartLinks().forEach(function(link) {
      ensureHeaderCartIcon(link);

      var badge = link.querySelector('.b2b-cart-badge');

      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'b2b-cart-badge';
        badge.setAttribute('aria-hidden', 'true');
        link.appendChild(badge);
      }

      badge.textContent = cartCount > 0 ? cartCount : '';

      if (cartCount > 0) {
        badge.hidden = false;
        badge.style.display = 'inline-flex';
      } else {
        badge.hidden = true;
        badge.style.display = 'none';
      }
    });

    updateStickyCart(cartCount);
  }

  function syncCartCountFromServer() {
    fetch(routesRoot + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function(response) {
        return response.json();
      })
      .then(function(cart) {
        updateHeaderCartCount(cart.item_count);
      })
      .catch(function() {
        updateHeaderCartCount(cartCount);
      });
  }

  function refreshCartDrawerLater() {
    window.setTimeout(function() {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer) return;

      fetch(routesRoot + '?sections=cart-drawer', { credentials: 'same-origin' })
        .then(function(response) {
          return response.json();
        })
        .then(function(sections) {
          if (!sections || !sections['cart-drawer']) return;

          var parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
          var newDrawer = parsed.querySelector('cart-drawer');

          if (newDrawer) drawer.innerHTML = newDrawer.innerHTML;
        })
        .catch(function() {});
    }, 600);
  }

  function showAddMessage(messageElement, text) {
    if (!messageElement) return;

    window.clearTimeout(messageElement._b2bHideTimer);

    messageElement.textContent = text;
    messageElement.classList.add('is-visible');

    messageElement._b2bHideTimer = window.setTimeout(function() {
      messageElement.classList.remove('is-visible');

      window.setTimeout(function() {
        if (!messageElement.classList.contains('is-visible')) {
          messageElement.textContent = '';
        }
      }, 400);
    }, 3000);
  }

  function formatB2BMoney(cents) {
    var amount = Math.round(Number(cents) || 0) / 100;
    var symbol = page.getAttribute('data-currency-symbol') || '€';

    try {
      return symbol + amount.toLocaleString('nl-NL', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    } catch (error) {
      return symbol + amount.toFixed(2).replace('.', ',');
    }
  }

  function updatePriceTotal(card, qty) {
    var output = card.querySelector('[data-price-output]');
    var inclOutput = card.querySelector('[data-price-incl-output]');

    if (!output) return;

    var unitPrice = Number(card.getAttribute('data-unit-price') || 0);
    var quantity = Math.max(1, Number(qty) || 1);
    var grossTotal = unitPrice * quantity;
    var netTotal = Math.round(grossTotal * 100 / 121);

    output.textContent = formatB2BMoney(netTotal);

    if (inclOutput) {
      inclOutput.textContent = formatB2BMoney(grossTotal);
    }
  }

  function updateStockWarning(card) {
    var input = card.querySelector('[data-qty-input]');
    var hiddenQty = card.querySelector('[data-hidden-qty]');
    var warning = card.querySelector('[data-stock-warning]');

    if (!input) return;

    var qty = Math.max(1, parseInt(input.value || '1', 10));
    var stock = parseInt(card.getAttribute('data-stock') || '0', 10);
    var tracksInventory = card.getAttribute('data-tracks-inventory') === 'true';

    input.value = qty;

    if (hiddenQty) hiddenQty.value = qty;

    updatePriceTotal(card, qty);

    if (warning) {
      warning.hidden = !(tracksInventory && stock > 0 && qty > stock);
    }
  }

  function applyFilters() {
    var searchInput = document.querySelector('[data-b2b-search]');
    var activeFilter = document.querySelector('.b2b-filter-tabs button.is-active');
    var query = searchInput ? (searchInput.value || '').trim().toLowerCase() : '';
    var filter = activeFilter ? activeFilter.getAttribute('data-b2b-filter') : 'all';
    var cards = document.querySelectorAll('[data-b2b-product]');
    var visibleCount = 0;

    cards.forEach(function(card) {
      var searchValue = (card.getAttribute('data-b2b-search') || '').toLowerCase();
      var availability = card.getAttribute('data-b2b-availability') || 'all';
      var matchesQuery = !query || searchValue.indexOf(query) !== -1;
      var matchesFilter = filter === 'all' || availability === filter;
      var show = matchesQuery && matchesFilter;

      card.hidden = !show;
      card.classList.remove('is-filtering-in');

      if (show) {
        visibleCount += 1;

        window.requestAnimationFrame(function() {
          card.classList.add('is-filtering-in');
        });
      }
    });

    var emptyState = document.querySelector('[data-b2b-empty]');

    if (emptyState) {
      emptyState.hidden = visibleCount !== 0;
    }
  }

  function initQuickOrder() {
    document.querySelectorAll('[data-b2b-product]').forEach(function(card) {
      var minus = card.querySelector('[data-qty-minus]');
      var plus = card.querySelector('[data-qty-plus]');
      var input = card.querySelector('[data-qty-input]');
      var form = card.querySelector('[data-b2b-add-form]');
      var button = card.querySelector('.b2b-add-btn');
      var message = card.querySelector('[data-add-message]');

      if (minus) {
        minus.addEventListener('click', function() {
          input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
          updateStockWarning(card);
        });
      }

      if (plus) {
        plus.addEventListener('click', function() {
          input.value = Math.max(1, parseInt(input.value || '1', 10) + 1);
          updateStockWarning(card);
        });
      }

      if (input) {
        input.addEventListener('input', function() {
          updateStockWarning(card);
        });
      }

      updateStockWarning(card);

      if (!form) return;

      form.addEventListener('submit', function(event) {
        event.preventDefault();

        if (!button || button.disabled) return;

        var variantId = form.getAttribute('data-variant-id');
        var qty = Math.max(1, parseInt(input.value || '1', 10));
        var previousText = button.textContent;
        var previousCount = cartCount;

        updateStockWarning(card);

        button.textContent = t('Toevoegen...');
        button.classList.add('is-loading');
        button.disabled = true;

        fetch(routesRoot + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: qty
              }
            ]
          })
        })
          .then(function(response) {
            if (!response.ok) {
              return response.json().then(function(error) {
                throw error;
              });
            }

            return response.json();
          })
          .then(function() {
            syncCartCountFromServer();
            refreshCartDrawerLater();

            button.textContent = t('Toegevoegd');
            button.classList.remove('is-loading');
            button.classList.add('is-added');

            showAddMessage(message, t('Toegevoegd aan je winkelwagen.'));

            window.setTimeout(function() {
              button.textContent = previousText;
              button.classList.remove('is-added');
              button.disabled = false;
            }, 3000);
          })
          .catch(function(error) {
            updateHeaderCartCount(previousCount);

            button.textContent = previousText;
            button.classList.remove('is-loading');
            button.disabled = false;

            showAddMessage(
              message,
              error && error.description ? error.description : t('Toevoegen lukt niet. Probeer het opnieuw.')
            );
          });
      });
    });
  }

  function setPanelOpen(panel, toggle, open, focusElement) {
    if (!panel || !toggle) return;

    window.clearTimeout(panel._b2bCloseTimer);
    panel.classList.remove('is-closing');

    toggle.classList.toggle('is-active', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');

    if (open) {
      panel.hidden = false;

      if (focusElement) {
        window.setTimeout(function() {
          focusElement.focus();
        }, 180);
      }
    } else {
      panel.classList.add('is-closing');

      panel._b2bCloseTimer = window.setTimeout(function() {
        panel.hidden = true;
        panel.classList.remove('is-closing');
      }, 230);
    }
  }

  function updatePanelRowState(filterToggle, searchToggle, panelRow) {
    if (!panelRow) return;

    var filterOpen = filterToggle && filterToggle.getAttribute('aria-expanded') === 'true';
    var searchOpen = searchToggle && searchToggle.getAttribute('aria-expanded') === 'true';

    panelRow.classList.toggle('has-two-panels', !!(filterOpen && searchOpen));
  }

  function initSearchAndFilters() {
    var searchInput = document.querySelector('[data-b2b-search]');
    var searchToggle = document.querySelector('[data-b2b-search-toggle]');
    var searchPanel = document.querySelector('[data-b2b-search-panel]');
    var searchClear = document.querySelector('[data-b2b-search-clear]');
    var filterToggle = document.querySelector('[data-b2b-filter-toggle]');
    var filterPanel = document.querySelector('[data-b2b-filter-panel]');
    var panelRow = document.querySelector('[data-b2b-order-panel-row]');

    if (searchToggle) {
      searchToggle.addEventListener('click', function() {
        var isOpen = searchToggle.getAttribute('aria-expanded') === 'true';
        setPanelOpen(searchPanel, searchToggle, !isOpen, searchInput);
        updatePanelRowState(filterToggle, searchToggle, panelRow);
      });
    }

    if (filterToggle) {
      filterToggle.addEventListener('click', function() {
        var isOpen = filterToggle.getAttribute('aria-expanded') === 'true';
        setPanelOpen(filterPanel, filterToggle, !isOpen);
        updatePanelRowState(filterToggle, searchToggle, panelRow);
      });
    }

    if (searchInput) {
      searchInput.addEventListener('input', function() {
        if (searchClear) {
          searchClear.hidden = (searchInput.value || '').trim() === '';
        }

        applyFilters();
      });
    }

    if (searchClear) {
      searchClear.addEventListener('click', function() {
        if (!searchInput) return;

        searchInput.value = '';
        searchClear.hidden = true;
        applyFilters();
        searchInput.focus();
      });
    }

    document.querySelectorAll('.b2b-filter-tabs button').forEach(function(button) {
      button.addEventListener('click', function() {
        document.querySelectorAll('.b2b-filter-tabs button').forEach(function(item) {
          item.classList.remove('is-active');
        });

        button.classList.add('is-active');
        applyFilters();
      });
    });

    updatePanelRowState(filterToggle, searchToggle, panelRow);
    applyFilters();
  }

  function initCartSyncEvents() {
    document.addEventListener('cart:updated', function() {
      window.setTimeout(syncCartCountFromServer, 150);
      window.setTimeout(function() {
        updateHeaderCartCount(cartCount);
      }, 700);
    });

    if (window.PUB_SUB_EVENTS && window.subscribe && PUB_SUB_EVENTS.cartUpdate) {
      try {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function() {
          window.setTimeout(syncCartCountFromServer, 150);
          window.setTimeout(syncCartCountFromServer, 900);
        });
      } catch (error) {}
    }

    document.addEventListener('click', function(event) {
      if (
        event.target.closest(
          'cart-drawer, cart-items, .cart-drawer, .cart__items, cart-remove-button, [href*="/cart/change"], [name="updates[]"], .quantity__button'
        )
      ) {
        window.setTimeout(syncCartCountFromServer, 250);
        window.setTimeout(syncCartCountFromServer, 900);
        window.setTimeout(syncCartCountFromServer, 1600);
      }
    });
  }

  function setupB2BLoginView() {
    if (!document.querySelector('[data-b2b-login-page]')) return;

    document.body.classList.add('b2b-login-view');
  }

  runWhenReady(function() {
    setupB2BLoginView();
    setupHeaderWithRetry();
    updateHeaderCartCount(cartCount);
    initQuickOrder();
    initSearchAndFilters();
    initCartSyncEvents();

    window.setTimeout(function() {
      setupHeaderMenu();
      syncCartCountFromServer();
    }, 500);
  });
})();
